<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-address"
  [activeStep]="1"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionDescription]="
    'activity_creation.address.section.description' | translate
  "
  [sectionTitle]="'activity_creation.address.section.title' | translate"
  (formSubmit)="submit($event)"
>
  <app-form-control [errorMessages]="placeErrorMessages">
    <app-form-address formControlName="address" [location]="address">
    </app-form-address>
  </app-form-control>
</app-organizer-shared-form-wrapper>
